import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import NumberFormat from 'react-number-format';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import Combobox from '../Helper/Combobox';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';

/**
* Class Caution
* Caution view component
**/
class Caution extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Caution";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    // Transforms date fields
    let dateVersement = null;
    let dateRemboursement = null;
    let dateFin = null;

    if(this.state.object !== undefined) {
      if(this.state.object.dateVersement) {

        dateVersement = this.state.object.dateVersement;

        if(typeof dateVersement === "string") {
          dateVersement = getDateFromString(dateVersement);
        }

        dateVersement = getIsoStringFromDate(dateVersement);
      }

      if(this.state.object.dateRemboursement) {

        dateRemboursement = this.state.object.dateRemboursement;

        if(typeof dateRemboursement === "string") {
          dateRemboursement = getDateFromString(dateRemboursement);
        }

        dateRemboursement = getIsoStringFromDate(dateRemboursement);
      }

      if(this.state.object.dateFin) {

        dateFin = this.state.object.dateFin;

        if(typeof dateFin === "string") {
          dateFin = getDateFromString(dateFin);
        }

        dateFin = getIsoStringFromDate(dateFin);
      }

    }

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="cautionForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de la caution.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idCaution" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idCaution")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="dateVersement">
            <Col componentClass={ControlLabel} sm={2}>Date de versement</Col>
            <Col sm={2}><DatePicker dateFormat="DD/MM/YYYY" value={dateVersement} onChange={this.handleDateVersementChange.bind(this)} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="dateFin">
            <Col componentClass={ControlLabel} sm={2}>Date de fin</Col>
            <Col sm={2}><DatePicker dateFormat="DD/MM/YYYY" value={dateFin} onChange={this.handleDateFinChange.bind(this)} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* ModePaiement ManyToOne */}
          <FormGroup controlId="idModePaiement">
            <Col componentClass={ControlLabel} sm={2}>Mode de paiement</Col>
            <Col sm={2}><Combobox url={REST_API_URL + "modepaiements/"} optionValueKey="idModePaiement" optionLabelKey="libelle"
              onChange={this.handleModePaiementChange.bind(this)} placeholder="Mode de paiement" default={this.getObjectProperty("idModePaiement")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Montant</Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("montant")} onValueChange={this.handleMontantChange.bind(this)}
                decimalScale={2} thousandSeparator={" "} suffix={'€'} disabled={this.getReadOnly()} />
            </Col>
          </FormGroup>

          <FormGroup controlId="dateRemboursement">
            <Col componentClass={ControlLabel} sm={2}>Date de remboursement</Col>
            <Col sm={2}><DatePicker dateFormat="DD/MM/YYYY" defaultValue={null} value={dateRemboursement} onChange={this.handleDateRemboursementChange.bind(this)} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* <FormGroup controlId="enCours">
            <Col smOffset={2} sm={2}><Checkbox name="enCours" onChange={this.handleCheckboxChange.bind(this)} checked={this.getObjectProperty("enCours")}
              disabled={this.getReadOnly() || dateRemboursement !== null}>en cours</Checkbox></Col>
          </FormGroup> */}

          <FormGroup controlId="commentaire">
            <Col componentClass={ControlLabel} sm={2} ><ControlLabel>Commentaire</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" onClick={this.submit.bind(this)}>Sauvegarder</Button>
              </Col>
            </FormGroup>: null
          }
        </Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idCaution";
  }

  /**
  * submit
  * Saves the data
  **/
  submit () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    let cautionObj = cloneObject(this.state.object);

    if(typeof cautionObj.dateVersement !== "string") {
      cautionObj.dateVersement = getStringFromDate(cautionObj.dateVersement);
    }

    if(typeof cautionObj.dateRemboursement !== "string") {
      cautionObj.dateRemboursement = getStringFromDate(cautionObj.dateRemboursement);
    }

    if(typeof cautionObj.dateFin !== "string") {
      cautionObj.dateFin = getStringFromDate(cautionObj.dateFin);
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(cautionObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Caution sauvegardée.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Caution créée.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/cautions/" + newObj.idCaution + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * handleDateVersementChange
  * Modify the state dateVersement property from dateVersement field change
  **/
  handleDateVersementChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateVersement"] = (dateString !== null) ? (dateString !== null) ? new Date(dateString) : null : null;
    this.setState(objState);
  }

  /**
  * handleDateFinChange
  * Modify the state dateFin property from dateFin field change
  **/
  handleDateFinChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateFin"] = (dateString !== null) ? (dateString !== null) ? new Date(dateString) : null : null;
    this.setState(objState);
  }

  /**
  * handleDateRemboursementChange
  * Modify the state dateRemboursement property from dateRemboursement field change
  **/
  handleDateRemboursementChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateRemboursement"] = (dateString !== null) ? (dateString !== null) ? new Date(dateString) : null : null;

    if(dateString !== null) {
      objState.object.enCours = false;
    }

    this.setState(objState);
  }

  /**
  * handleModePaiementChange
  * Modify the state idModePaiement property from idModePaiement Combobox change
  **/
  handleModePaiementChange(modePaiement) {
    let objState = this.state;
    objState.object["idModePaiement"] = modePaiement.idModePaiement;
    this.setState(objState);
  }

  /**
  * handleMontantChange
  * Handle montant change
  **/
  handleMontantChange(values) {
    let objState = this.state;
    objState.object["montant"] = values.value;
    this.setState(objState);
  }

}
export default Caution;



// WEBPACK FOOTER //
// ./src/views/Entity/Caution.js